'use client';

import { type PropsWithChildren } from 'react';
import { SnackbarProvider } from 'notistack';
import type { Nullable } from '@libs/core';
import { TwoLineSnackbar } from '../components';

export type SnackbarWrapperProps = Record<string, unknown>;

declare module 'notistack' {
    interface VariantOverrides {
        twoLine: true;
    }
}

export function SnackbarWrapperProvider({ children }: PropsWithChildren<Nullable<SnackbarWrapperProps>>) {
    return (
        <SnackbarProvider
            Components={{
                twoLine: TwoLineSnackbar,
            }}
        >
            {children}
        </SnackbarProvider>
    );
}
